import { Section, SectionTitle, CaseCard } from './shared';

export function DeploymentContent() {
  const deploymentCases = [
    {
      icon: '☁️',
      title: 'CloudBase 自动化部署',
      description: '用 CloudBase 自动化开发一个网站并部署上线,实现全栈自动化',
      tags: ['CloudBase', '自动化部署', '全栈开发'],
      difficulty: 'advanced' as const,
      link: 'https://curl.qcloud.com/vIlzcNDW',
    },
  ];

  return (
    <div className="space-y-8">
      <Section>
        <SectionTitle>开发部署案例</SectionTitle>
        <p className="text-slate-400 mb-6">
          利用 OpenClaw 实现开发流程自动化,从代码编写到部署上线的全流程管理。
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {deploymentCases.map((caseItem, index) => (
            <CaseCard key={index} {...caseItem} />
          ))}
        </div>
      </Section>

      <Section>
        <div className="bg-cyan-500/10 border border-cyan-500/50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-cyan-400 mb-3">💡 自动化流程</h3>
          <ul className="space-y-2 text-slate-300">
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>自动化代码生成和优化</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>CI/CD 流程集成</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>一键部署到云平台</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>监控和日志管理</span>
            </li>
          </ul>
        </div>
      </Section>
    </div>
  );
}